define("SDB.SDBLocations.EntryPoint", [
  "SDB.SDBLocations.View",
  "SDB.SDBLocations.SocialMedia.View",
  "SDB.SDBLocations.Modal.View",
  "SDB.SDBLocations.Model",
  "SDB.Financing.View",
  "SDB.Locations.Finance.View",
  "Manage.LocationAddress.EntryPoint",
  "Header.Menu.View",
  "SDB.Locations.Finance.Modal.View",
  "SDB.SDBLocations.Phone.View",
  "ItemsSearcher.Item.View",
  "SuiteDB.SDBLocations.SDBContactForm.View",
  "Header.View",
  "Facets.Browse.View",
  "Facets.Browse.CategoryHeading.View",
  "Utils",
  "Profile.Model",
  "CartSEO.EntryPoint",
], function (
  SDBLocationsView,
  SDBLocationsSocialMediaView,
  SDBLocationsModal,
  SDBLocationsModel,
  SDBFinancingView,
  SDBLocationsFinanceView,
  ManageLocationAddressEntryPoint,
  HeaderMenuView,
  SDBLocationsFinanceModal,
  SDBLocationsPhone,
  ItemsSearcherItemView,
  SDBContactFormView,
  HeaderView,
  FacetsBrowseView,
  FacetsBrowseCategoryHeadingView,
  Utils,
  ProfileModel,
  CartSEOEntryPoint
) {
  "use strict";

  var BLACKLISTED_QUERY_PARAM_KEYS = [
    "page",
    "display",
    "order",
    "show",
    "keywords",
    "srsltid",
  ];
  var WHITELISTED_QUERY_PARAM_KEYS = [
    "custitem_sdb_feature_item",
    "pricelevel5",
    "custitemrs_attributes",
    "custitemrs_brand",
    "custitemrs_model",
    "custitemrs_tire_inside_diameter",
    "custitem_sdb_tire_load_index_filter",
    "custitemrs_tire_service_type",
    "custitemrs_wheel_bolt_patterns",
    "custitem_sdb_wheel_centerbore_filter",
    "custitemrs_wheel_diameter_min",
    "custitemrs_wheel_finish_category",
    "custitem_sdb_wheel_offset_min_filter",
    "custitem_sdb_wheel_width_filter",
    "custitemrs_p_tire_height",
    "custitemrs_p_tire_width",
    "custitemrs_p_wheel_offset_category",
    "custitem_cca_trending_item",
    "FeaturedItem",
    "pricelevel5",
    "Attributes",
    "Brand",
    "Model",
    "InsideDiameter",
    "custitem_sdb_tire_load_index_filter",
    "ServiceType",
    "BoltPattern",
    "custitem_sdb_wheel_centerbore_filter",
    "WheelDiameter",
    "FinishCategory",
    "custitem_sdb_wheel_offset_min_filter",
    "custitem_sdb_wheel_width_filter",
    "AspectRatio",
    "TireWidth",
    "OffsetCategory",
    "custitem_cca_trending_item",
  ];

  function filterQueryParamsToArray(rawFilters) {
    return rawFilters
      .split("&")
      .map(function (filter) {
        return filter.split("=");
      })
      .filter(function (filter) {
        return BLACKLISTED_QUERY_PARAM_KEYS.indexOf(filter[0]) === -1;
      })
      .filter(function (filter) {
        return WHITELISTED_QUERY_PARAM_KEYS.indexOf(filter[0]) !== -1;
      })
      .map(function (filter) {
        filter[1] = decodeURIComponent(filter[1]);
        return filter;
      });
  }

  function filterQueryParams(rawFilters) {
    return rawFilters
      .split("&")
      .filter(function (filter) {
        var key = filter.split("=")[0];
        return (
          BLACKLISTED_QUERY_PARAM_KEYS.indexOf(key) === -1 &&
          WHITELISTED_QUERY_PARAM_KEYS.indexOf(key) !== -1
        );
      })
      .join("&");
  }

  function getPaginationUrl(path, page) {
    var rawFilters = Backbone.history.fragment.split("?")[1] || "";
    var filteredFilters = filterQueryParams(rawFilters);
    var queryParts = [];

    if (page > 1) {
      queryParts.push("page=" + page);
    }
    if (filteredFilters) {
      queryParts.push(filteredFilters);
    }

    return path + (queryParts.length ? "?" + queryParts.join("&") : "");
  }

  function loadGoogleMapsScript() {
    if (
      !document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')
    ) {
      var script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyANVWr4j_okxgPC_ssCRfPZrPC2B1R-2Yo&libraries=maps,marker&callback=initMap";
      // Consider adding 'async' or 'defer' attributes for better performance
      script.async = true;
      document.head.appendChild(script);
    }
  }

  function capitalizeFirstLetter(str) {
    if (str.length === 0) {
      return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return {
    mountToApp: function mountToApp(container) {
      var Environment = container.getComponent("Environment");
      // if (true || !Environment.isPageGenerator()) {
      try {
        var model = SDBLocationsModel.getInstance();
        var locationsList = model.getLocations();
        ManageLocationAddressEntryPoint.mountToApp(container);
        CartSEOEntryPoint.mountToApp(container);

        $("body").removeClass("modal-open");
        $(".modal-backdrop").remove();
        var PageType = container.getComponent("PageType");
        var Layout = container.getComponent("Layout");
        var LoginRegister = container.getComponent("LoginRegisterPage");
        var Checkout = container.getComponent("Checkout");
        var Profile = ProfileModel.getInstance();

        var defaultRemoveOptions = ["location", "shoppingExperience"];

        //remove cookies if the selected location has been disabled
        var selectedLocation = model.getSelectedLocation();
        if (
          selectedLocation &&
          !_.findWhere(locationsList, { internalid: selectedLocation.internalid })
        )
          _.each(defaultRemoveOptions, function (cookie) {
            model.removeCookie(cookie);
          });


        if (PageType) {
          var pageType = {
            name: "finance_page",
            routes: ["finance"],
            view: SDBLocationsFinanceView,
            options: { container: container },
            defaultTemplate: {
              name: "sdb_locations_finance.tpl",
              displayName: "Finance",
              thumbnail: "",
            },
          };

          PageType.registerPageType(pageType);
        }

        if (!Environment.isPageGenerator()) {
          if (Layout) {
            Layout.addChildView("financing_home", function () {
              return new SDBFinancingView({ container: container });
            });
            /* Set the locations childview for the header */
            Layout.addChildView("StoreLocatorCustomLink", function () {
              return new SDBLocationsView({ container: container });
            });
            /* Set the locations childview for the social media */
            Layout.addChildView("Locations.SocialMedia", function () {
              return new SDBLocationsSocialMediaView({ container: container });
            });
            Layout.addChildView("LocationsButtons", function () {
              return new SDBLocationsModal({
                container: container,
                onlyBtns: true,
              });
            });
            Layout.addChildView("FinanceModal", function () {
              return new SDBLocationsFinanceModal({
                container: container,
                showContent: true,
              });
            });
            Layout.addChildView("Phone.View", function () {
              return new SDBLocationsPhone({
                container: container,
              });
            });
            Layout.addChildView("Sidebar.Phone.View", function () {
              return new SDBLocationsPhone({
                container: container,
                isSidebar: true,
              });
            });
            Layout.addChildView("ContactForm", function () {
              return new SDBContactFormView({
                container: container,
              });
            });

            // HeaderMenuView.prototype.getContext = _.wrap(HeaderMenuView.prototype.getContext, function (fn) {
            //     var selectedLocation = model.getSelectedLocation();
            //     var shoppingExperience = model.getShoppingExperience();

            //     var context = fn.apply(this, _.toArray(arguments).slice(1));
            //     var categories = context.categories;
            //     if (!selectedLocation || shoppingExperience == 'online') {
            //         var categoriesWithoutFinancing = categories.filter(function (category) {
            //             return category.classnames != 'location-needed';
            //         });
            //         context.categories = categoriesWithoutFinancing;
            //     }
            //     return context;
            // });

            /* Validate if we are not on the login page because the signout link is not there */
            // if (!LoginRegister) {
            //     /* Set an event to remove the cookies on logout */
            //     Layout.addToViewEventsDefinition(
            //         'Header.Menu.MyAccount.View',
            //         'click [data-action="signout"]',
            //         removeCookieDefaultOptions
            //     );
            // }
          }
        }

        // if (!Environment.isPageGenerator()) {
        if (Checkout) {
          var removeGuestCreateAccount = function removeGuestCreateAccount() {
            var checkoutSteps = require("SC.Checkout.Configuration.Steps.OPC");
            if (!checkoutSteps) return;
            if (checkoutSteps.OPC) checkoutSteps = checkoutSteps.OPC;
            var reviewStep = _.findWhere(checkoutSteps, { name: "Review" });
            if (!reviewStep) return;
            var confirmationStep = _.findWhere(reviewStep.steps, {
              url: "confirmation",
            });
            if (!confirmationStep) return;
            var registerGuestModuleIndex = _.findIndex(
              confirmationStep.modules,
              function (value) {
                return (
                  _.isArray(value) &&
                  value[0].prototype.className ==
                  "OrderWizard.Module.RegisterGuest"
                );
              }
            );
            if (!(registerGuestModuleIndex > -1)) return;
            confirmationStep.modules.splice(registerGuestModuleIndex, 1);
          };
          removeGuestCreateAccount();

          var confirmationPage = require("OrderWizard.Module.Confirmation");
          confirmationPage.prototype.getContext = _.wrap(
            confirmationPage.prototype.getContext,
            function (fn) {
              var ctx = fn.apply(this, Array.prototype.slice.call(arguments, 1));
              if (Profile && Profile.get("isGuest") == "T") {
                ctx.isGuest = true;
                model.on("change:finishedExternal", function signout(model) {
                  model.off("change:finishedExternal", signout);
                  fetch(SC.SESSION.touchpoints.logout);
                });
              }
              return ctx;
            }
          );
        }
        // }

        // if (LoginRegister) {
        //     /* Set an event to remove cookies on login */
        //     LoginRegister.on('beforeLogin', removeCookieDefaultOptions);
        // }

        this.initMap = function initMap() {
          model.on("change:loadContactMap", function () {
            var center = new google.maps.LatLng(53.4876882, -113.4839807);
            var mapOptions = {
              center: center,
              zoom: 5,
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              mapId: "CCAW_Locations",
              disableDefaultUI: true,
              zoomControl: true,
              cameraControl: true,
              streetViewControl: true,
            };

            var map = new google.maps.Map(
              document.getElementById("map"),
              mapOptions
            );

            var markersData = [
              {
                lat: 55.157672,
                lng: -118.8377497,
                title: "8610 112 St, Grande Prairie, AB T8V 5X4, Canada",
                header: "Canada Custom Autoworks - Grand Prairie",
                content: "8610 112 St<br>Grande Prairie, AB T8V 5X4, Canada",
              },
              {
                lat: 49.8541256,
                lng: -119.5921254,
                title: "2900 E Boundary Rd, #101, Westbank, BC V4T 2H2, Canada",
                header: "Canada Custom Autoworks - Kelowna",
                content:
                  "2900 E Boundary Rd, #101<br>Westbank, BC V4T 2H2, Canada",
              },
              {
                lat: 51.0024402,
                lng: -113.9689866,
                title: "5610 46 Street Southeast, Calgary, AB T2C 4P9, Canada",
                header: "Canada Custom Autoworks - Calgary",
                content:
                  "5610 46 Street Southeast<br>Calgary, AB T2C 4P9, Canada",
              },
              {
                lat: 52.2961648,
                lng: -113.842959,
                title: "6540 71 St, Bay 3, Red Deer, AB T4P 3Y7, Canada",
                header: "Canada Custom Autoworks - Red Deer",
                content: "6540 71 St, Bay 3<br>Red Deer, AB T4P 3Y7, Canada",
              },
              {
                lat: 53.5400001,
                lng: -113.8883397,
                title: "495 South Ave Unit 156, Spruce Grove, AB T7X 4G2, Canada",
                header: "Canada Custom Autoworks - Spruce Grove",
                content:
                  "495 South Ave Unit 156<br>Spruce Grove, AB T7X 4G2, Canada",
              },
              {
                lat: 53.4876882,
                lng: -113.4839807,
                title: "9751 51 Ave NW, Edmonton, AB T6E 4W8, Canada",
                header: "Canada Custom Autoworks - Edmonton South",
                content: "9751 51 Ave NW<br>Edmonton, AB T6E 4W8, Canada",
              },
              {
                lat: 53.7145014,
                lng: -113.1806699,
                title: "108, 11602 88 Ave, Fort Sask, AB T8L 0K1, Canada",
                header: "Canada Custom Autoworks - Fort Saskatchewan",
                content: "108, 11602 88 Ave<br>Fort Sask, AB T8L 0K1, Canada",
              },
              {
                lat: 53.300344,
                lng: -110.0139557,
                title: "5114 62 Street, Lloydminster, AB T9V 2E4, Canada",
                header: "Canada Custom Autoworks - Lloydminster",
                content: "5114 62 Street<br>Lloydminster, AB T9V 2E4, Canada",
              },
              {
                lat: 52.1617904,
                lng: -106.6686061,
                title: "302, 44 ST East, Saskatoon, SK S7K 8A7, Canada",
                header: "Canada Custom Autoworks - Saskatoon",
                content: "302, 44 ST East<br>Saskatoon, SK S7K 8A7, Canada",
              },
              {
                lat: 50.4682998,
                lng: -104.5594396,
                title: "614 Solomon Cres, Regina, SK S4N 4N7, Canada",
                header: "Canada Custom Autoworks - Regina",
                content: "614 Solomon Cres<br>Regina, SK S4N 4N7, Canada",
              },
            ];

            var currentInfoWindow;
            map.addListener("click", function () {
              if (!currentInfoWindow) return;
              currentInfoWindow.close();
              currentInfoWindow = null;
            });
            _.each(markersData, function (markerInfo) {
              var position = new google.maps.LatLng(
                markerInfo.lat,
                markerInfo.lng
              );
              var marker = new google.maps.marker.AdvancedMarkerElement({
                position: position,
                map: map,
                title: markerInfo.title,
              });
              var directionsUrl =
                "https://www.google.com/maps/dir/?api=1&destination=" +
                markerInfo.lat +
                "," +
                markerInfo.lng;
              var contentString =
                '<div id="content">' +
                '<h3 id="firstHeading" class="firstHeading">' +
                markerInfo.header +
                "</h3>" +
                '<br><div id="bodyContent">' +
                "<p>" +
                markerInfo.content +
                "</p>" +
                '<br><a class="button-primary button-small" target="_blank" href="' +
                directionsUrl +
                '">Get Directions</a>' +
                "</div>" +
                "</div>";
              var infowindow = new google.maps.InfoWindow({
                content: contentString,
              });
              marker.addListener("gmp-click", function () {
                if (currentInfoWindow) {
                  var sameInfoWindow =
                    infowindow.content == currentInfoWindow.content;
                  currentInfoWindow.close();
                  currentInfoWindow = null;
                  if (sameInfoWindow) return;
                }
                currentInfoWindow = infowindow;
                infowindow.open({
                  anchor: marker,
                  map: map,
                });
              });
            });
          });
        };

        window.initMap = _.bind(this.initMap, this);

        // if (!Environment.isPageGenerator()) {
        var menuView;
        HeaderMenuView.prototype.initialize = _.wrap(
          HeaderMenuView.prototype.initialize,
          function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;
            menuView = self;

            this.listenTo(model, "change:location", function () {
              self.render();
            });

            this.listenTo(model, "change:shoppingExperience", function () {
              if (model.getShoppingExperience() === "online") self.render();
            });
          }
        );

        HeaderView.prototype.showSidebar = _.wrap(
          HeaderView.prototype.showSidebar,
          function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            if (menuView) menuView.render();
          }
        );

        ItemsSearcherItemView.prototype.getContext = _.wrap(
          ItemsSearcherItemView.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            if (!context.model) return context;
            if (context.model.attributes.custitem_sdb_item_hide_price) {
              context.model.attributes.pricelevel5_formatted =
                "Contact for pricing";
            }
            return context;
          }
        );
        // }

        // if (!Environment.isPageGenerator()) {
        _.extend(FacetsBrowseView.prototype, {
          getAddToHead: function getAddToHead() {
            var category = this.model.get("category");
            if (!category) {
              return '<meta name="robots" content="noindex, nofollow">';
            }
            return category.get("addtohead") || this.addToHead;
          },
          getPath: function getPath() {
            var base_url =
              window.location.protocol + "//" + window.location.hostname;
            if (this.model.get("category")) {
              var category_canonical =
                this.model.get("category").get("canonical") ||
                this.model.get("category").get("fullurl");
              return (
                (category_canonical.indexOf("/") === 0 ? base_url : "") +
                category_canonical
              );
            } else {
              var fragmentPath = Backbone.history.fragment
                .split("?")[0]
                .replace(/\/+$/, "");
              return base_url + "/" + fragmentPath;
            }
          },
          getCanonical: function getCanonical() {
            var canonicalPath = this.getPath()
              .split(/[?#]/)[0]
              .replace(/\/+$/, "");

            return getPaginationUrl(canonicalPath, 1);
          },
          getRelPrev: function getRelPrev() {
            var currentPage = this.translator.getOptionValue("page");
            return currentPage > 1
              ? getPaginationUrl(this.getPath(), currentPage - 1)
              : null;
          },
          getRelNext: function getRelNext() {
            var currentPage = this.translator.getOptionValue("page");
            return currentPage < this.totalPages
              ? getPaginationUrl(this.getPath(), currentPage + 1)
              : null;
          },
          getMetaDescription: function getMetaDescription() {
            var category = this.model.get("category");
            if (!category) {
              return this.metaDescription;
            }
            // var description = (category && category.get('metadescription')) || this.metaDescription;
            if (this.isCategoryPage)
              return (
                (category && category.get("metadescription")) ||
                this.metaDescription
              );
            var canonicalSplitted = (
              category.get("canonical") || category.get("fullurl")
            )
              .split("/")
              .reverse();
            var categoryName = canonicalSplitted[0];
            var categoryType = canonicalSplitted[1].toUpperCase();
            var rawFilters =
              Backbone.history.fragment.split("?").length > 1
                ? Backbone.history.fragment.split("?")[1]
                : "";
            var filters = rawFilters
              ? filterQueryParamsToArray(rawFilters).map(function (filter) {
                return filter[1];
              })
              : [];
            var currentCategoryDescription =
              (categoryType
                ? categoryType + " " + categoryName + " " + filters.join(" ")
                : capitalizeFirstLetter(categoryName)) +
              " ❱❱❱ fast shipping, low prices, best service!";
            return (
              "❱❱❱ Wheels & Rims for Cars, Trucks ❱❱❱ from Canada Custom Autoworks ❱❱❱ " +
              currentCategoryDescription
            );
          },
          getTitle: function getTitle() {
            if (this.isCategoryPage)
              return this.model.get("category").get("pagetitle") || this.title;
            var category = this.model.get("category");
            if (!category) {
              if (this.translator.getOptionValue("keywords")) {
                return Utils.translate(
                  'Search results for "$(0)"',
                  this.translator.getOptionValue("keywords")
                );
              }
              return this.application.getConfig().defaultSearchTitle;
            }
            // var title = (category && category.get('pagetitle')) || this.title;
            var canonicalSplitted = (
              category.get("canonical") || category.get("fullurl")
            )
              .split("/")
              .reverse();
            var categoryName = canonicalSplitted[0];
            var categoryType = capitalizeFirstLetter(canonicalSplitted[1]);
            if (!categoryType) {
              return (
                capitalizeFirstLetter(categoryName) +
                " | Tires & Wheels in Canada"
              );
            }
            var rawFilters =
              Backbone.history.fragment.split("?").length > 1
                ? Backbone.history.fragment.split("?")[1]
                : "";
            var filters = rawFilters
              ? filterQueryParamsToArray(rawFilters).map(function (filter) {
                return filter[1];
              })
              : [];
            var currentCategoryTitle =
              categoryType + " " + categoryName + " " + filters.join(" | ");
            return (
              "Buy " + currentCategoryTitle.trim() + " | Tires & Wheels in Canada"
            );
          },
        });
        // }

        // if (!Environment.isPageGenerator()) {
        FacetsBrowseCategoryHeadingView.prototype.getContext = _.wrap(
          FacetsBrowseCategoryHeadingView.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var rawFilters =
              Backbone.history.fragment.split("?").length > 1
                ? Backbone.history.fragment.split("?")[1]
                : "";
            var filters = rawFilters
              ? filterQueryParamsToArray(rawFilters).map(function (filter) {
                return filter[1].replace(/,/g, ", ");
              })
              : [];
            context.pageheading += " " + filters.join(" | ");
            return context;
          }
        );
        // }

        if (!Environment.isPageGenerator()) {
          setTimeout(function () {
            loadGoogleMapsScript();
          }, 0);
        }

      } catch (error) {
        console.error("Error in SDBLocations EntryPoint:", error);
      }
      // }
    },
  };
});
